<template>
  <div v-if="rpc_template_info" class="rpc_template_info">
    <div class="rpc_template_info__left">
      <div class="line row">
        <div class="col-md-6 col-sm-6">
          <fg-input
              v-model="rpc_template_info.name"
              type="text"
              :label="translate('task_list.templates.name')"
              :placeholder="translate('task_list.templates.name')"
          />
        </div>
        <div class="col-md-3 col-sm-3">
          <fg-input
              v-model.number="rpc_template_info.timeout"
              type="number"
              :min="0"
              :label="translate('rpc_template.timeout')"
              :placeholder="translate('rpc_template.timeout')"
          />
        </div>
        <div class="col-md-3 col-sm-3">
          <div class="filter checkbox">
            <div class="info">
              {{ translate('rpc_template.visible') }}
            </div>
            <label class="switch" @click.prevent="rpc_template_info.visible = !rpc_template_info.visible">
              <input type="checkbox" v-model="rpc_template_info.visible">
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="line row">
        <div class="col-md-12 col-sm-12">
          <fg-input v-model="rpc_template_info.command" type="text" :label="translate('task_list.templates.command')"
                    :placeholder="translate('task_list.templates.command')" :readonly="true" />
        </div>
      </div>

      <div class="line row">
        <div class="col-md-12 col-sm-12 form-group">
          <label>{{ translate('task_list.templates.client_name') }}</label>
          <tree-select
              v-model="rpc_template_info.client_ids"
              :options="client_list"
              :multiple="true"

              :placeholder="translate('task_list.templates.client_name')"
          />
        </div>
      </div>

      <div class="line row">
        <div class="col-md-4 col-sm-4">
          <fg-input
              v-model="rpc_template_info.use_count"
              type="text"
              :label="translate('task_list.templates.use_count')"
              :placeholder="translate('task_list.templates.use_count')"
              :readonly="true"
          />
        </div>
        <div class="col-md-4 col-sm-4">
          <fg-input
              v-model="date_create"
              type="text"
              :label="translate('rpc_template.ts_create')"
              :placeholder="translate('rpc_template.ts_create')"
              :readonly="true"
          />
        </div>
        <div class="col-md-4 col-sm-4">
          <fg-input
              v-model="date_update"
              type="text"
              :label="translate('rpc_template.ts_update')"
              :placeholder="translate('rpc_template.ts_update')"
              :readonly="true"
          />
        </div>
      </div>
      <div class="line row">
        <div class="col-md-6 col-sm-6 text_wrap">
          <div class="form-group">
            <label>{{ translate('rpc_template.command_params') }}</label>
            <textarea class="input_text" rows="12" :value="command_params" readonly />
          </div>
        </div>
        <div class="col-md-6 col-sm-6 text_wrap">
          <div class="form-group">
            <label>{{ translate('rpc_template.requirements') }}</label>
            <textarea class="input_text" rows="12" :value="requirements" readonly />
          </div>
        </div>
      </div>
      <div class="line text-center">
        <span
            v-if="has_changes"
            class="btn btn-success btn-fill btn-wd"
            @click.prevent="edit_rpc_template"
        >
          {{ translate('btn.edit') }}
        </span>
      </div>
      <div class="response_table" v-if="rpc_template_info.cmd_history && rpc_template_info.cmd_history.length > 0">
        <table>
          <thead>
          <tr>
            <th>{{ translate('tariffication.device') }}</th>
            <th>{{ translate('task.command') }}</th>
            <th>{{ translate('rpc_template.history.output') }}</th>
            <th>{{ translate('task.status') }}</th>
            <th>{{ translate('task.username') }}</th>
            <th>{{ translate('rpc_template.history.started') }}</th>
            <th>{{ translate('rpc_template.history.finished') }}</th>
            <th>{{ translate('rpc_template.history.mass_rpc') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="task in rpc_template_info.cmd_history" :key="task.id">
            <td :data-label="translate('tariffication.device')" class="device_name">
              <router-link :to="{path: '/device/' + task.device_fid}">
                {{ task.device_fid }}
              </router-link>
              <p>{{ task.device_name }}</p>
            </td>
            <td :data-label="translate('task.command')">{{ task.in }}</td>
            <td :data-label="translate('rpc_template.history.output')">{{ task.out }}</td>
            <td :data-label="translate('task.status')">{{ task.status }}</td>
            <td :data-label="translate('task.username')">{{ task.user_name }}</td>
            <td :data-label="translate('rpc_template.history.started')" v-html="get_date_any_lines(task.ts, null, 2)"></td>
            <td :data-label="translate('rpc_template.history.finished')" v-html="get_date_any_lines(task.ts_end, null, 2)"></td>
            <td :data-label="translate('rpc_template.history.mass_rpc')">{{ task.device_massive_rpc_id }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="rpc_template_info__right">
      <Summary
        type="rpc_template"
        :info="rpc_template_info"
        :view_history="false"
      />
    </div>
  </div>
</template>

<script>

import Summary from "components/UIComponents/Summary/Summary.vue";

const fields_to_check = ["name", "client_ids", "visible", "timeout"];

export default {
  name: 'RpcTemplateInfo',
  components: {
    Summary
  },

  props: {
    rpc_template: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      rpc_template_info: {}
    }
  },

  created() {
    this.rpc_template_info = JSON.parse(JSON.stringify(this.rpc_template))
  },

  activated() {
    this.rpc_template_info = JSON.parse(JSON.stringify(this.rpc_template))
  },

  computed: {
    client_list(){
      let clients = this.$store.getters.getClientsList.map((client) => {
        return {label: client.name, id: Number(client.id)}
      })
      this.rpc_template.clients.forEach((client) => {
        if (!clients.find((item) => item.id === Number(client.client_id))) {
          clients.push({label: client.client_name, id: Number(client.client_id)})
        }
      })
      return clients
    },
    date_create() {
      return this.get_date(this.rpc_template.ts_create)
    },
    date_update() {
      return this.get_date(this.rpc_template.ts_update)
    },
    command_params() {
      let params = this.rpc_template.command_params
      return params == null ? '' : typeof params === 'string' ? params : JSON.stringify(params, null, 2)
    },
    requirements() {
      let requirements = this.rpc_template.requirements
      return requirements == null ? '' : typeof requirements === 'string' ? requirements : JSON.stringify(requirements, null, 2)
    },
    has_changes() {
      let main_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.rpc_template[key];
        return obj;
      }, {});

      let rpc_template_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.rpc_template_info[key];
        return obj;
      }, {});

      main_info.client_ids = [...main_info.client_ids].sort((a, b) => a - b)
      rpc_template_info.client_ids = [...rpc_template_info.client_ids].sort((a, b) => a - b)

      return JSON.stringify(main_info) !== JSON.stringify(rpc_template_info);
    }
  },

  watch: {
    rpc_template(){
      this.rpc_template_info = JSON.parse(JSON.stringify(this.rpc_template))
    }
  },

  methods: {
    edit_rpc_template() {
      let params = fields_to_check.reduce((obj, key) => {
        obj[key] = this.rpc_template_info[key];
        return obj;
      }, {});

      this.$http.v1.updateRPCTemplate(this.rpc_template_info.id, params, () => {
        this.global_notify('info', this.translate('saved'))
        this.$emit('update')
      })
    }
  }
}

</script>

<style lang='scss' scoped>
.rpc_template_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  &__left {
    width: 70%;
    height: 100%;
    padding-right: 10px;
    .form-group {
      margin-bottom: 10px;
    }
    .response_table{
      height: auto;
      flex-grow: 0;
      padding: 0;
      > table {
        height: auto;
        flex-grow: 0;
        > tbody {
          height: auto;
          max-height: 300px;
          flex: none;
        }
      }
      .device_name{
        a,p{
          font-size: 12px;
          margin-bottom: 0;
        }
      }
    }
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }

  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }

}
</style>
